var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 174,
    viewBox: "0 0 158 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.654907,
    y: 66.0352,
    width: 12,
    height: 42.6089,
    rx: 6,
    fill: "#FF6D34"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "2s",
    repeatCount: "indefinite",
    values: "42.6089;20;42.6089",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "2s",
    repeatCount: "indefinite",
    values: "66.0352;77;66.0352",
    keyTimes: "0;0.5;1"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8096,
    y: 40.104,
    width: 12,
    height: 93.7931,
    rx: 6,
    fill: "#FF6D34"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "1.5s",
    repeatCount: "indefinite",
    values: "93.7931;50;93.7931",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.5s",
    repeatCount: "indefinite",
    values: "40.104;62;40.104",
    keyTimes: "0;0.5;1"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9648,
    y: 50.4717,
    width: 12,
    height: 73.0575,
    rx: 6,
    fill: "#FF6D34"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "73.0575;40;73.0575",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "50.4717;67;50.4717",
    keyTimes: "0;0.5;1"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1195,
    y: 33.3096,
    width: 12,
    height: 107.381,
    rx: 6,
    fill: "#FF6D34"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "1.8s",
    repeatCount: "indefinite",
    values: "107.381;60;107.381",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.8s",
    repeatCount: "indefinite",
    values: "33.3096;57;33.3096",
    keyTimes: "0;0.5;1"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2742,
    y: 24.4561,
    width: 12,
    height: 125.088,
    rx: 6,
    fill: "#FF6D34"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "1.7s",
    repeatCount: "indefinite",
    values: "125.088;70;125.088",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.7s",
    repeatCount: "indefinite",
    values: "24.4561;52;24.4561",
    keyTimes: "0;0.5;1"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 121.429,
    y: 44.0947,
    width: 12,
    height: 85.8107,
    rx: 6,
    fill: "#FF6D34"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "1.4s",
    repeatCount: "indefinite",
    values: "85.8107;40;85.8107",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.4s",
    repeatCount: "indefinite",
    values: "44.0947;67;44.0947",
    keyTimes: "0;0.5;1"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 145.584,
    y: 66.0352,
    width: 12,
    height: 42.8137,
    rx: 6,
    fill: "#FF6D34"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    dur: "1.6s",
    repeatCount: "indefinite",
    values: "42.8137;20;42.8137",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.6s",
    repeatCount: "indefinite",
    values: "66.0352;77;66.0352",
    keyTimes: "0;0.5;1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeLines);
export default __webpack_public_path__ + "static/media/OrangeLines.02ca0ce4116eaf78e17b39a6d2ce6964.svg";
export { ForwardRef as ReactComponent };